import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {
  "Title": "Frames"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "how-frames-works"
    }}>{`How frames works`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`Frames`}</inlineCode>{` are the part of the simulation in charge of rendering the internal state.`}</p>
    <p>{`Given a `}<inlineCode parentName="p">{`data`}</inlineCode>{` and a `}<inlineCode parentName="p">{`tick`}</inlineCode>{` prop, the `}<inlineCode parentName="p">{`Frames`}</inlineCode>{` paint a view of that information.`}</p>
    <p>{`When the `}<inlineCode parentName="p">{`Model`}</inlineCode>{` refreshes the animation, it sends updated `}<inlineCode parentName="p">{`tick`}</inlineCode>{` and `}<inlineCode parentName="p">{`data`}</inlineCode>{` to the `}<inlineCode parentName="p">{`Frames`}</inlineCode>{`, so the `}<inlineCode parentName="p">{`Frames`}</inlineCode>{` rerender and show fresh information.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`Frames`}</inlineCode>{` only job is to render the data. `}<inlineCode parentName="p">{`updateData`}</inlineCode>{` does the calculation on the data, the `}<inlineCode parentName="p">{`Model`}</inlineCode>{` manages the animation and `}<a parentName="p" {...{
        "href": "/react-sim/controls"
      }}>{`controls`}</a>{` let the user interact with the Model.`}</p>
    <p>{`This is a completely declarative approach, consistent with the React approach.`}</p>
    <h1 {...{
      "id": "how-to-connect-frames-and-the-model"
    }}>{`How to connect Frames and the Model`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`Frames`}</inlineCode>{` receive some information from the `}<inlineCode parentName="p">{`Model`}</inlineCode>{`.`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`data`}</inlineCode>{` (anything), the current state of the simulation.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`tick`}</inlineCode>{` (integer), the progress in the simulation.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`params`}</inlineCode>{` (object), all the parameters set by the user/author, which don't change over time without intervention.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`cachedData`}</inlineCode>{` (object), data from previous `}<inlineCode parentName="li">{`ticks`}</inlineCode>{` of the simulation, and`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`results`}</inlineCode>{` (array), data from previous completed runs of the simulation,`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`initData`}</inlineCode>{` (function), the Frame can reinitialize data,`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`setData`}</inlineCode>{` (function), the Frame can change the data. (so for instance the Frame can be used to let the user enter an initial state of data).`}</li>
    </ul>
    <p>{`The `}<inlineCode parentName="p">{`Frames`}</inlineCode>{` can be one or more components.`}</p>
    <p>{`The easiest way to connect `}<inlineCode parentName="p">{`Frames`}</inlineCode>{` to a `}<inlineCode parentName="p">{`Model`}</inlineCode>{` is just to have these components as children of the Model:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Model>
  <MyFrame />
</Model>
`}</code></pre>
    <p>{`A component which is a direct child of `}<inlineCode parentName="p">{`Model`}</inlineCode>{` will receive all of the props above from `}<inlineCode parentName="p">{`Model`}</inlineCode>{`.`}</p>
    <p>{`This also works if there are several children:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Model>
  <MyFrame />
  <MyOtherFrame />
</Model>
`}</code></pre>
    <p>{`All components will receive these props. The children will be arranged from left to right.`}</p>
    <p>{`However, it doesn't work if the components are deep into the tree, ie:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Model>
  <div>
    <MyFrame />
  </div>
</Model>
`}</code></pre>
    <p>{`Here, `}<inlineCode parentName="p">{`<MyFrame />`}</inlineCode>{` won't receive the frame props, because it is too deep.
To connect `}<inlineCode parentName="p">{`Frames`}</inlineCode>{` deep in the tree, we can use the `}<inlineCode parentName="p">{`withFrames`}</inlineCode>{` wrapper.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { withFrames, Model } from 'react-sim';
import MyFrame from 'my-frame';

const MyConnectedFrame = withFrames(MyFrame);

export default () => (
  <Model>
    <div>
      <MyConnectedFrame />
    </div>
  </Model>
);
`}</code></pre>
    <p>{`Here, `}<inlineCode parentName="p">{`<MyConnectedFrame />`}</inlineCode>{` receives the `}<inlineCode parentName="p">{`frames`}</inlineCode>{` props.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      